import React from "react";
import Routers from "./utils/router/router";
import "./App.css";
import configureStore from "./store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// react-helmet is unmaintained and triggers UNSAFE_componentWillMount on
// React 18. Replaced project-wide with react-helmet-async, which requires a
// HelmetProvider at the top of the tree.
import { HelmetProvider } from "react-helmet-async";

const store = configureStore();
function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routers />
      </Provider>
    </HelmetProvider>
  );
}

export default App;
